import { createSlice } from "@reduxjs/toolkit";
import { searchProductByImage } from "./ThunkActions";
import { iProductSearchState, REDUCER_NAME } from "./Types";

const initialState: iProductSearchState = {
  isLoading: false,
  // products: [],
  products: null,
  errorMessage: null,
};

export const productSearchSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetProductSearchState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder

      // ✅ IMAGE SEARCH LOADING
      .addCase(searchProductByImage.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
        state.products = null;
      })
     .addCase(searchProductByImage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload || [];
      })


      // ✅ IMAGE SEARCH FAILED
      .addCase(searchProductByImage.rejected, (state, action) => {
        state.isLoading = false;
        state.products = null;
        state.errorMessage =
          //@ts-ignore
          action.payload?.message || "Failed to search product by image";
      });
  },
});

export const { resetProductSearchState } =
  productSearchSlice.actions;

export default productSearchSlice.reducer;
